// Modal open/close on product page
var modalTrigger = $('[data-role=modal-trigger]');
var modal = $('.cstm-modal');
var modalContent = $(".cstm-modal .cstm-modal-content");

modalTrigger.click(function () {
  var getModalId = $(this).attr('modal-target');
  $(getModalId).css('display', 'flex');
  $('body').css('overflow', 'hidden');
});

$('[modal-close]').click(function () {
  $(modal).css('display', 'none');
  $('body').css('overflow', 'visible');
});

$(modal).mouseup(e => {
  if (!modalContent.is(e.target) && modalContent.has(e.target).length === 0) {
    $(modal).css('display', 'none');
    $('body').css('overflow', 'visible');
  }
});

// Tabs on product page
$('.cstm-tab-title').on('click', function () {
  var tab = $(this).attr('data-id');
  $('.cstm-tab-title').removeClass('active');
  $(this).addClass('active');
  $('.cstm-tab-info').removeClass('show');
  $(this).closest('.custom-tabs').find('.' + tab).addClass('show');
});
